<template>
    <div class="metal_block" v-if="metals">
        <div class="over_flow">
            <div class="metal_flex mx-auto">
                <div class="metal_box" v-for="item in metals" :key="item.id" :class="{ 'active': item.selected }"
                    @click="changeMetal(item.metal)">
                    <div>
                        <img v-if="item.icon==='white'" width="50" height="50" src="~/assets/metals/white.png" alt="white gold"/>
                        <img v-if="item.icon==='yellow'" width="50" height="50" src="~/assets/metals/yellow.png" alt="yellow gold"/>
                        <img v-if="item.icon==='rose'" width="50" height="50" src="~/assets/metals/rose.png" alt="rose gold"/>
                    </div>
                  
                    <p class="metal-label">{{ item.short_label }}</p>
                </div>
            </div>
        </div>
        <!-- {{options}} -->
    </div>
</template>

<script setup>
    const props = defineProps(['metals', 'selectedMetal'])
    const emit = defineEmits(['toggleOption'])

    function changeMetal(option) {
        emit('toggleOption', option)
    }
    
</script>
<style scoped>
::-webkit-scrollbar {
    width: 2px;
    height: 3px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f5f5f5; 
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #c4c4c4; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #c4c4c4; 
}


.metal_label {
    display: flex;
    align-items: center;
}

.metal_label label {
    text-transform: capitalize;
    font-weight: 600;
}

.metal_label span {
    text-transform: capitalize;
    font-weight: 600;
    color: var(--green);
    margin-left: 10px;
}

.metal_label {
    display: flex;
    align-items: center;
}

.metal_label label {
    text-transform: capitalize;
    font-weight: 600;
}

.metal_label span {
    text-transform: capitalize;
    font-weight: 600;
    color: var(--green);
    margin-left: 10px;
}

.metal_flex {
    display: flex;
    align-items: flex-start;
    /* padding: 2% 0 0; */
    gap: 20px;
    max-width: 100%;
    overflow: auto;
    max-width: max-content;
}

.metal_box {
    cursor: pointer;
}

.metal_box p {
    color: #606060;
    font-size: 14px;
    text-transform: uppercase;
    min-width: 46px;
    display: inline-block;
    text-align: center;
    margin-bottom: 0;
}

.metal_box.active p {
    color: var(--green);
    font-weight: 600;
}

/* .over_flow {
    overflow-x: scroll;
    overflow-y: hidden;
} */

@media(max-width: 1050px) {
    .metal_flex {
        /* min-width: 450px; */
    }
}

@media(max-width: 767px) {
    .metal_flex {
        padding-bottom: 0;
    }
    
    .metal_box svg.svg-metal {
        /* transform: scale(0.7); */
    }
    
    .metal_label {
        font-size: 14px;
    }
}
</style>